import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  deliveryApi,
  type DepotPayload,
} from "@/lib/admin-api/delivery";

// ---------------------------------------------------------------------------
// Query key
// ---------------------------------------------------------------------------

const DEPOTS_KEY = "admin-depots";

// ---------------------------------------------------------------------------
// Hooks
// ---------------------------------------------------------------------------

export function useDepots() {
  return useQuery({
    queryKey: [DEPOTS_KEY],
    queryFn: () => deliveryApi.depots.list(),
    staleTime: 30_000,
  });
}

export function useCreateDepot() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: DepotPayload) => deliveryApi.depots.create(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DEPOTS_KEY] });
    },
  });
}

export function useUpdateDepot() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      payload,
    }: {
      id: string;
      payload: Partial<DepotPayload>;
    }) => deliveryApi.depots.update(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DEPOTS_KEY] });
    },
  });
}
